import { createTheme } from '@material-ui/core/styles';

export const toolbarheight = "24px";
export const footerHeight = "24px";
export let theme = createTheme({
        palette: {
                primary: {
                        light: '#4eabbb',
                        main: '#2296aa',
                        dark: '#176976',
                        // contrastText: will be calculated to contrast with palette.primary.main
                    },
                secondary: {
                        //light: '#0066ff',
                        main: '#ff6d00',
                        // dark: will be calculated from palette.secondary.main,
                        //contrastText: '#ffcc00',
                    },
                // Used by `getContrastText()` to maximize the contrast between
                // the background and the text.
                contrastThreshold: 3,
                // Used by the functions below to shift a color's luminance by approximately
                // two indexes within its tonal palette.
                // E.g., shift from Red 500 to Red 300 or Red 700.
                tonalOffset: 0.2,
            },
        mixins: {
                toolbar: {
                        minHeight: toolbarheight
                    }
            },
        overrides: {
                MuiTab: {
                        wrapper: {
                                flexDirection: 'row',
                            },
                    },
            },
        breakpoints: {
                values: {
                        xs: 0,
                        sm: 600,
                        md: 790,
                        lg: 1280,
                        xl: 1920,
                    },
            }
    });